import { createContext, useMemo } from 'react';

export const PriceCurrencyContext = createContext({
  currency: 'usd',
  currencyCode: 'USD',
  currencySymbol: '$',
});

const PriceCurrencyProvider = ({ children, currency }) => {
  const value = useMemo(() => ({
    currency,
    currencyCode: currency === 'usd' ? 'USD' : 'GBP',
    currencySymbol: currency === 'usd' ? '$' : '£',
  }), [currency]);

  return (
    <PriceCurrencyContext.Provider value={value}>
      {children}
    </PriceCurrencyContext.Provider>
  );
};

export default PriceCurrencyProvider;
